import type { RouteObject } from 'react-router-dom'
import { AgentAccessPage } from './AgentAccessPage'
import { AgentConnectPage } from './AgentConnectPage'
import { InvoicesPage } from './InvoicesPage'
import { LinkRequestsPage } from './LinkRequestsPage'

export const routes: RouteObject[] = [
  { path: '/agent/connect', element: <AgentConnectPage /> },
  { path: '/partner/agent', element: <AgentAccessPage /> },
  { path: '/staff/agent', element: <AgentAccessPage /> },
  { path: '/invoices', element: <InvoicesPage /> },
  { path: '/partner/link-requests', element: <LinkRequestsPage /> },
]
